import { useEffect } from "react";
import NorRecord from "./AboutNorRecord";
import RndRecord from "./AboutRndRecord";

function AboutRecord({ getLink, getData }) {
    useEffect(() => {
      getLink(window.location.href);
      getData(
        "수행 실적",
        "다양한 프로젝트를 수행하며 디지털 트윈과 ",
        "관련된 기술을 보유하고 있습니다."
      );
    }, [getLink, getData]);
    
    return(
        <div className="inner">
            <NorRecord/>
            <RndRecord/>
        </div>
    )    
}

export default AboutRecord;